import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useHasSuggestedText = () => {
	const { userTags } = useUserTags();

	return userTags.includes(tags.suggestedTexts);
};
